// extracted by mini-css-extract-plugin
module.exports = {"frameRoot":"typeform_frameRoot__L1PF5"};